module.exports = __webpack_public_path__ + "img/avatar-exercise-02.489b66f5.png";